import { render, staticRenderFns } from "./UserPreferencesSpeedDial.vue?vue&type=template&id=a06800e4&scoped=true&"
import script from "./UserPreferencesSpeedDial.vue?vue&type=script&lang=js&"
export * from "./UserPreferencesSpeedDial.vue?vue&type=script&lang=js&"
import style0 from "./UserPreferencesSpeedDial.vue?vue&type=style&index=0&id=a06800e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06800e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a06800e4')) {
      api.createRecord('a06800e4', component.options)
    } else {
      api.reload('a06800e4', component.options)
    }
    module.hot.accept("./UserPreferencesSpeedDial.vue?vue&type=template&id=a06800e4&scoped=true&", function () {
      api.rerender('a06800e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/UserPreferencesSpeedDial.vue"
export default component.exports